import request from '@/utils/request'

export function fetchFranchiseeList(data) {
  return request({
    url: '/merchant-api/mch/franchisee/list',
    method: 'post',
    data
  })
}

export function searchFranchisees(data) {
  return request({
    url: '/merchant-api/mch/franchisee/search',
    method: 'post',
    data
  })
}

export function fetchFranchiseeDetail(franchiseeNo) {
  return request({
    url: `/merchant-api/mch/franchisee/detail/${franchiseeNo}`,
    method: 'get'
  })
}

export function createFranchisee(data) {
  return request({
    url: '/merchant-api/mch/franchisee/create',
    method: 'post',
    data
  })
}

export function updateFranchisee(data) {
  return request({
    url: '/merchant-api/mch/franchisee/update',
    method: 'put',
    data
  })
}
